export const addStringParam = (paramValue, paramText) => {
  if (paramValue) {
    return `&${paramText}=${encodeURI(paramValue)}`;
  }
};

export const addArrayParam = (paramValue, paramText) => {
  if (paramValue !== null && paramValue.length) {
    return paramValue.reduce((acc, cur) => `${acc}&${paramText}=${encodeURI(cur)}`, '');
  }
  return '';
};

export const addBooleanParam = (paramValue, paramText) => {
  if (paramValue !== null) {
    return `&${paramText}=${paramValue}`;
  }
  return '';
};

export const UrlMaker = (url) => {
  let urlParametersArray = [];

  function addKeyAndString(key, string) {
    if (string) {
      const urlPiece = key + '=' + encodeURI(string);
      urlParametersArray.push(urlPiece);
    }
  }

  function addKeyAndArray(key, array) {
    if (array.length) {
      array.forEach((item) => {
        const urlPiece = key + '=' + encodeURI(item);
        urlParametersArray.push(urlPiece);
      });
    }
  }

  function addKeyAndBoolean(key, boolean) {
    if (boolean !== null) {
      const urlPiece = key + '=' + boolean;
      urlParametersArray.push(urlPiece);
    }
  }

  function getURL() {
    return url + '?' + urlParametersArray.join('&');
  }

  return { addKeyAndBoolean, addKeyAndString, addKeyAndArray, getURL };
};
